import { Installment } from '~/components'
import { addMonthsInBrazil, getNextBankWorkdayInBrazil, setDayInBrazil } from '@mutual-libs/date'

type CreateInstallmentsParameter = {
  numberOfInstallments: number,
  installmentValue: number
}

export const createInstallments = ({ installmentValue, numberOfInstallments }: CreateInstallmentsParameter): Installment[] => {
  const initialDate = new Date()
  const mouthFirstDay = setDayInBrazil(initialDate, 1)
  const firstInstallmentDueDate = addMonthsInBrazil(mouthFirstDay, 2)

  const installments: Installment[] = [{
    installmentValue,
    installmentNumber: 1,
    dueDate: getNextBankWorkdayInBrazil(firstInstallmentDueDate)
  }]

  for (let i = 1; i < numberOfInstallments; i++) {
    const newInstallmentDueDate = getNextBankWorkdayInBrazil(addMonthsInBrazil(firstInstallmentDueDate, i))

    const newInstallment: Installment = {
      installmentValue,
      installmentNumber: i + 1,
      dueDate: newInstallmentDueDate
    }

    installments.push(newInstallment)
  }

  return installments
}
